import React, { useState } from "react";
import { Col, Row } from "react-bootstrap";
import * as i18n from "util/i18n";
import MainContainer from "pages/_components/MainContainer";
import Button from "pages/_components/Button";
import Action from "pages/_components/Action";
import { TransactionCard, TransactionHeader } from "pages/_components/TransactionCard";
import { ResponsiveHeader, DesktopButtons, MobileButtons } from "pages/_components/header";
import useReactPrint from "pages/_components/Print/useReactToPrint";
import { actions as echeckActions } from "reducers/echecks";
import { useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { bool } from "prop-types";
import Notification from "pages/_components/Notification";
import { useTransaction } from "hooks/useTransactions";
import { isIOS } from "react-device-detect";
import PayDebinSummaryBody from "./Summary";

const ActionAvalTransactionPage = ({ isDesktop }) => {
    const { echeqsToDoActions } = useSelector((state) => state.echecks);
    const { state = {} } = useLocation();
    const { isFlowComplete = false } = state;
    const formatTransactionAval = (data, idTransaction) => ({ ...data, idTransaction });

    const {
        isLoading,
        transaction,
        dispatch,
        handleSignTransaction,
        showSignButton,
        push,
        id,
        status,
    } = useTransaction(
        "/echecks/aval/actions/sumary",
        echeckActions.setAvalDetail,
        echeckActions.cleanEcheckTicket,
        formatTransactionAval,
    );
    let title;
    if (echeqsToDoActions?.action === "AVAL-ANULATE") {
        title = "echeq.anulate.aval.echeq";
    }
    if (echeqsToDoActions?.action === "AVAL-REPUDIATE") {
        title = "echeq.repudiate.aval.echeq";
    }
    if (echeqsToDoActions?.action === "AVAL-ADMIT") {
        title = "echeq.accept.aval.echeq";
    }
    if (!echeqsToDoActions?.action) {
        title = "echeq.update.aval.echeq";
    }
    const { componentRef, handlePrint, handlePrintMobile, mobileRef, handleShareMobile } = useReactPrint(
        title,
        id,
        "updateEcheqAval",
    );
    const [showMoreData, setShowMoreData] = useState(!isDesktop);
    const { isFinished, isBackoffice } = status;
    const backLinkTo = isFlowComplete ? "/echecks" : "";

    const handleDownloadMobile = async () => {
        await setShowMoreData(true);
        return handlePrintMobile();
    };
    const handleDownloadDesktop = async () => {
        await setShowMoreData(true);
        return handlePrint();
    };

    return (
        <>
            <Notification scopeToShow="updateEcheqAval" />
            {!isBackoffice && (
                <ResponsiveHeader ticket metaTitle={title} backLinkTo={backLinkTo}>
                    {isFinished && (
                        <>
                            <DesktopButtons>
                                <Button
                                    className="btn btn-outline"
                                    image="images/download.svg"
                                    label="global.download"
                                    onClick={handleDownloadDesktop}
                                    block={false}
                                />
                            </DesktopButtons>
                            <MobileButtons
                                image={
                                    isIOS ? "images/figma/icon/menu-ios-white.svg" : "images/figma/icon/menu-ios.svg"
                                }>
                                <Action labelKey="global.download" handleClick={handleDownloadMobile} />
                                <Action labelKey="global.share" handleClick={handleShareMobile} />
                            </MobileButtons>
                        </>
                    )}
                </ResponsiveHeader>
            )}
            <MainContainer showLoader={isLoading}>
                <div className="container" ref={componentRef}>
                    <div ref={mobileRef}>
                        <TransactionCard transaction={transaction}>
                            <TransactionHeader title={title} />
                            <div className="ticket">
                                <div className="ticket__wrapper">
                                    <div className="ticket__header" />
                                    <PayDebinSummaryBody
                                        ticket
                                        isDesktop={isDesktop}
                                        setShowMoreData={setShowMoreData}
                                        showMoreData={showMoreData}
                                    />
                                    <div className="ticket__footer" data-copytext={i18n.get("global.ticketCopyText")} />
                                </div>
                            </div>
                        </TransactionCard>
                    </div>
                    {!isBackoffice && (
                        <Row className="form-actions no-print">
                            <Col xs={12} md={4} mdOffset={showSignButton ? 2 : 4}>
                                <Button
                                    onClick={() => dispatch(push("/desktop"))}
                                    label="forms.transaction.ticket.actions.backToHome"
                                    className={`btn${showSignButton ? " btn-outline" : " btn-primary"}`}
                                />
                            </Col>
                            {showSignButton && (
                                <Col xs={12} md={4}>
                                    <Button
                                        onClick={handleSignTransaction}
                                        label="forms.signTransaction.link"
                                        className="btn btn-primary"
                                    />
                                </Col>
                            )}
                        </Row>
                    )}
                </div>
            </MainContainer>
        </>
    );
};

ActionAvalTransactionPage.propTypes = {
    isDesktop: bool.isRequired,
};

export default ActionAvalTransactionPage;
